import { ArrowBack } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import banner from "../../Assets/banners/storybanner.png";
import NarrateSearchButton from "./NarrateSearchButton";

export default function HeaderStory() {
  const [scrolled, setScrolled] = useState(false);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const navigate = useNavigate();

  const bannerImages = [banner];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBannerIndex((prevIndex) => 
        prevIndex === bannerImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [bannerImages.length]);

  return (
    <header
      className="relative w-full h-[323px] bg-cover bg-center shadow-2xl overflow-hidden group transition-all duration-1000 ease-in-out"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.6)), url('${bannerImages[currentBannerIndex]}')`,
      }}
    >
      {/* Crossfade overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out opacity-0"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.6)), url('${bannerImages[(currentBannerIndex + 1) % bannerImages.length]}')`,
        }}
      />

      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/40"></div>

      {/* Navigation Bar */}
      <nav className={`absolute top-0 left-0 right-0 p-6 transition-all duration-500 ${scrolled ? 'bg-black/80 backdrop-blur-lg' : ''}`}>
        <div className="max-w-7xl mx-auto flex justify-between items-center">

          {/* Back Button */}
          <button
            onClick={() => navigate(-1)} // <- Go back in history
            className="w-12 h-12 bg-white/10 backdrop-blur-lg rounded-lg flex items-center justify-center
            text-white hover:bg-white/20 transition-all duration-300 hover:scale-110 border border-white/20"
          >
            <ArrowBack />
          </button>

          {/* Search Button */}
          <div className="flex justify-end items-center space-x-4">
            <NarrateSearchButton />
          </div>
        </div>
      </nav>
    </header>
  );
}
